// src/components/HomeAbout.jsx

import React from 'react';
import { Link } from 'react-router-dom';

const Star = () => (
  <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
    <path d="M10 1.5l2.6 5.6 6.1.6-4.6 4.1 1.3 6-5.4-3.2-5.4 3.2 1.3-6-4.6-4.1 6.1-.6L10 1.5z" />
  </svg>
);

const TESTIMONIALS = [
  {
    name: 'أحمد محمد',
    role: 'عميل دائم',
    text: 'تجربة شراء ممتازة وسرعة في التوصيل. المنتجات وصلت بنفس الجودة الموجودة في الصور.',
  },
  {
    name: 'سارة علي',
    role: 'عميلة',
    text: 'خدمة العملاء رائعة وتم الرد على استفساري بسرعة كبيرة. أنصح بالتعامل معهم.',
  },
  {
    name: 'محمود حسن',
    role: 'عميل منذ 2024',
    text: 'أسعار ممتازة وعروض مستمرة. أصبح المتجر المفضل لدي للتسوق عبر الإنترنت.',
  },
];

const STATS = [
  { value: '5000+', label: 'منتج' },
  { value: '10K+', label: 'عميل' },
  { value: '99%', label: 'رضا العملاء' },
];

const HomeAbout = () => {
  return (
    <section className="py-20 bg-white overflow-hidden" dir="rtl">
      <div className="container mx-auto px-4">

        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* الصورة */}
          <div className="relative">
            {/* شكل زخرفي خلفي يعطي عمق للصورة */}
            <div className="absolute -top-8 -right-8 w-full h-full rounded-[2.5rem] bg-[#F2B705]/20 -z-10" />

            <div className="relative rounded-[2rem] overflow-hidden shadow-2xl group">
              <img
                src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1200&q=80"
                alt="MEME STORE"
                className="w-full h-[500px] object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B1B1F]/40 via-transparent to-transparent" />
            </div>

            <div className="absolute -bottom-6 -left-6 bg-[#1B1B1F] text-white p-6 rounded-2xl shadow-xl flex items-center gap-4">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#F2B705] text-[#1B1B1F] text-xl">
                ★
              </span>
              <div>
                <h3 className="text-2xl font-extrabold leading-none">10K+</h3>
                <p className="text-sm text-white/70 mt-1">عميل سعيد</p>
              </div>
            </div>
          </div>

          {/* المحتوى */}
          <div>
            <span className="inline-block px-4 py-2 rounded-full bg-[#F2B705]/15 text-[#1B1B1F] font-bold mb-5 tracking-wide">
              من نحن
            </span>

            <h2
              className="text-4xl md:text-5xl font-extrabold text-[#1B1B1F] leading-tight mb-6"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              تجربة تسوق حديثة تجمع بين
              <span className="relative inline-block mx-2 text-[#1B1B1F]">
                الجودة والثقة
                <svg
                  viewBox="0 0 200 12"
                  className="absolute -bottom-1 right-0 w-full h-3 text-[#F2B705]"
                  preserveAspectRatio="none"
                >
                  <path d="M2 9 C 50 2, 150 2, 198 9" stroke="currentColor" strokeWidth="5" fill="none" strokeLinecap="round" />
                </svg>
              </span>
            </h2>

            <p className="text-gray-600 text-lg leading-8 mb-8">
              في MEME STORE نوفر مجموعة متنوعة من المنتجات المختارة بعناية
              لتلبية احتياجات عملائنا. نسعى لتقديم تجربة تسوق سهلة وآمنة مع
              أفضل الأسعار وخدمة عملاء مميزة وشحن سريع.
            </p>

            {/* الإحصائيات */}
            <div className="grid grid-cols-3 gap-5 mb-8">
              {STATS.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-[#F6F5F2] rounded-2xl p-5 text-center transition-colors hover:bg-[#F2B705]/15"
                >
                  <h3 className="text-3xl font-extrabold text-[#1B1B1F]">
                    {stat.value}
                  </h3>
                  <p className="text-gray-500 text-sm mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <Link
              to="/about-us"
              className="
                inline-flex items-center gap-2
                px-8 py-3
                rounded-full
                bg-[#F2B705]
                text-[#1B1B1F]
                font-bold
                hover:bg-[#1B1B1F]
                hover:text-white
                transition-all duration-300
              "
            >
              اعرف المزيد
              <span aria-hidden="true">←</span>
            </Link>
          </div>

        </div>

        {/* آراء العملاء */}
        <div className="mt-24">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1 rounded-full bg-[#F2B705]/15 text-[#1B1B1F] text-sm font-bold mb-3 tracking-wide">
              آراء العملاء
            </span>

            <h2
              className="text-3xl md:text-4xl font-bold text-[#1B1B1F]"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              ماذا يقول عملاؤنا؟
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {TESTIMONIALS.map((t) => (
              <div
                key={t.name}
                className="relative bg-[#F6F5F2] p-7 rounded-2xl shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <span
                  className="absolute top-4 left-6 text-6xl leading-none text-[#F2B705]/25 font-serif select-none"
                  aria-hidden="true"
                >
                  ”
                </span>

                <div className="flex items-center gap-1 text-[#F2B705] mb-4">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} />
                  ))}
                </div>

                <p className="text-gray-700 leading-relaxed relative z-10">
                  {t.text}
                </p>

                <div className="mt-5 pt-5 border-t border-[#1B1B1F]/10 flex items-center gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#1B1B1F] text-[#F2B705] font-bold text-sm">
                    {t.name.charAt(0)}
                  </span>
                  <div>
                    <h4 className="font-bold text-[#1B1B1F] leading-none">
                      {t.name}
                    </h4>
                    <span className="text-sm text-gray-500">{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default HomeAbout;
